import React from "react";
import { getLabel } from "../../data/labels";

export default function ConfirmModalContent(props) {

    function close() {
        if(props.close) {
            props.close();
        }
    }

    function onConfirm() {
        if(props.onConfirm) {
            props.onConfirm();
        }
        close();
    }

    function onCancel() {
        if(props.onCancel) {
            props.onCancel();
        }
        close();
    }

   return (
        <div className= {"purchaseResponseMessage "}  >
            <span className={"purchaseResponseMessageSignal"} >
					{props.title}
			</span>	
            {props.message}
            <br/><br/>
            <div className="bottoni-quota-variata"  >
                    <button onClick={onConfirm}className="bottone bg-verde bianco maiuscolo">{getLabel('general.yes')}</button>
                    <button onClick={onCancel} className="bottone bg-rosso bianco maiuscolo">{getLabel('general.no')}</button>
            </div>
        </div>
    )
}